import API from "./baseApi";

const getCustomers = (payload) => {
  API.defaults.headers.common["x-tenant-id"] = payload.tenantId;
  return API.post("/customers/find", payload);
};

const getBulkUploadUsers = (payload) => {
  API.defaults.headers.common["x-tenant-id"] = payload.tenantId;
  return API.post("/customers/bulkupload_users/find", payload);
};

// Member Benefits
const getMemberBenefitForCust = (payload) => {
  API.defaults.headers.common["x-tenant-id"] = payload.tenantId;
  return API.post("/customers/member-benefits/get", payload);
};

const getAllMemberBenefitForCustomer = (payload) => {
  API.defaults.headers.common["x-tenant-id"] = payload.tenantId;
  return API.post("/member-benefitsv2/getAllMemberBenefitForCustomer", payload);
};

const resetMemberBenefits = (payload) => {
  API.defaults.headers.common["x-tenant-id"] = payload.tenantId;
  return API.post("/member-benefitsv2/resetMemberBenefits", payload);
};

const createMemberBenefitForCust = (payload) => {
  API.defaults.headers.common["x-tenant-id"] = payload.tenantId;
  return API.post("/customers/member-benefits/create", payload);
};
const updateMemberBenefitForCust = (payload) => {
  API.defaults.headers.common["x-tenant-id"] = payload.tenantId;
  return API.post("/customers/member-benefits/update", payload);
};
const deleteMemberBenefitForCust = (payload) => {
  API.defaults.headers.common["x-tenant-id"] = payload.tenantId;
  return API.post("/customers/member-benefits/delete", payload);
};


export default {
  getCustomers,
  getBulkUploadUsers,

  getMemberBenefitForCust,
  getAllMemberBenefitForCustomer,
  createMemberBenefitForCust,
  updateMemberBenefitForCust,
  deleteMemberBenefitForCust,
  resetMemberBenefits
};
